const navTypeMap = new Map();

navTypeMap.set("index",0);
navTypeMap.set("mall",3);
navTypeMap.set("sns",4);
navTypeMap.set("video",5);
navTypeMap.set("ucenter",9);

export function getCurrIndexByURL(url){
	let currIndex = 0;

	// 去掉url开头的/
    url = url.slice(1);
    for(let [key,value] of navTypeMap){
         if(url.startsWith(key)){
             currIndex = value;
             break;
         }
    }

    return currIndex;
}
